import { render, staticRenderFns } from "./q-banner.vue?vue&type=template&id=3fdad3e0&"
import script from "./q-banner.vue?vue&type=script&lang=js&"
export * from "./q-banner.vue?vue&type=script&lang=js&"
import style0 from "./q-banner.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports